import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import lang from '../../Translation/Ladning.json'

const Notification = () => {


  // Local notifications array
  const notifications = [
    {
      id: 1,
      message:
        "Pembayaran sewa bulanan Zon 2 telah berjaya direkodkan. Sila semak laporan terkini.",
    },
    {
      id: 2,
      message:
        "Perhatian! Beberapa penyewa masih belum membuat bayaran penuh bagi bulan ini.",
    },
    {
      id: 3,
      message:
        "Notis penyelenggaraan akan dikeluarkan untuk Zon 4 minggu hadapan.",
    },
  ];

  return (
    <div className="p-5 rounded-md shadow-md border bg-white max-h-[50vh] overflow-auto">
      <h4 className="mb-3 text-lg font-semibold uppercase text-gray-700">
       {lang.Notification}
      </h4>

      {notifications.map((note) => (
        <div
          key={note.id}
          className="flex items-start mb-3 p-2 rounded-md hover:bg-blue-50 transition duration-200"
        >
          <span>
            <FontAwesomeIcon
              icon={faBell}
              className="text-blue-700 text-lg me-3 mt-1"
            />
          </span>
          <p className="text-gray-700 text-sm leading-relaxed">{note.message}</p>
        </div>
      ))}
    </div>
  );
};

export default Notification;
